<template>
  <label class="input-container">
    <span v-if="label" class="txt-secondary">{{ label }}</span>

    <input
      class="border-gray-200 bg-white text-gray-900 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-100"
      :class="{ 'input-margin': error, ...inputClasses }"
      :value="value"
      :type="type"
      :placeholder="placeholder"
      :readonly="readonly"
      :disabled="disabled"
      :style="styles"
      @input="onChange"
      @blur="onBlur"
    />

    <p v-if="helpText" class="help-text">{{ helpText }}</p>

    <span v-if="error" v-dompurify-html="error" class="message" />
    <slot name="masked" />
  </label>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    helpText: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    inputClasses: {
      type: String,
      default: '',
    },
  },
  methods: {
    onChange(e) {
      this.$emit('input', e.target.value);
    },
    onBlur(e) {
      this.$emit('blur', e.target.value);
    },
  },
};
</script>
<style scoped lang="scss">
.input-container {
  & > input.no-margin {
    margin-bottom: 0;
  }
}
.help-text {
  @apply mt-0.5 text-xs not-italic text-gray-600 dark:text-gray-400;
}

.message {
  margin-top: 0 !important;
}
</style>
